function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { isInSameViewPage, startOf } from './dateUtilsOld';
import dayjs from 'dayjs';
import { CALENDAR_POSITION, DOUBLE_DECADE_ORDERS, DOUBLE_MONTH_ORDERS, DOUBLE_YEAR_ORDERS, NEXT_BUTTON, PREV_BUTTON, SINGLE_DECADE_ORDERS, SINGLE_MONTH_ORDERS, SINGLE_YEAR_ORDERS } from './constants';
function arrRemove(arr, ele) {
  return arr.filter(function (e) {
    return ele !== e;
  });
}
export function getKeyTable(e) {
  //mac support
  var isTab = e.key === 'Tab';
  var isDown = e.key === 'ArrowDown';
  var isUp = e.key === 'ArrowUp';
  var isLeft = e.key === 'ArrowLeft';
  var isRight = e.key === 'ArrowRight';
  var isEnter = e.key === 'Enter';
  var isDirection = isDown || isUp || isLeft || isRight;
  var isEsc = e.key === 'Escape';
  var isShift = e.shiftKey;
  var isctrl = e.ctrlKey;
  var isBackspace = e.key === 'Backspace';
  var isCmd = /Mac|iPod|iPhone|iPad/.test(navigator.platform) && e.metaKey;
  var isChar = e.keyCode >= 65 && e.keyCode <= 90 || e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode >= 96 && e.keyCode <= 107 || e.keyCode >= 109 && e.keyCode <= 111 || e.keyCode >= 186 && e.keyCode <= 191 || e.keyCode === 37 || e.keyCode === 39;
  var isSpace = e.keyCode === 32;
  var isCtrlOptionSpace = e.ctrlKey && e.altKey && isSpace;
  return {
    isSpace: isSpace,
    isBackspace: isBackspace,
    isChar: isChar,
    isTab: isTab,
    isDown: isDown,
    isUp: isUp,
    isLeft: isLeft,
    isRight: isRight,
    isEnter: isEnter,
    isDirection: isDirection,
    isEsc: isEsc,
    isShift: isShift,
    isctrl: isctrl,
    isCmd: isCmd,
    isCtrlOptionSpace: isCtrlOptionSpace
  };
}
export function getTabOrders(view, calendarPosition, disabled, isInDoubleCalendar, leftPanelRefList) {
  var monthOrders = isInDoubleCalendar ? DOUBLE_MONTH_ORDERS : SINGLE_MONTH_ORDERS;
  var yearOrders = isInDoubleCalendar ? DOUBLE_YEAR_ORDERS : SINGLE_YEAR_ORDERS;
  var decadeOrders = isInDoubleCalendar ? DOUBLE_DECADE_ORDERS : SINGLE_DECADE_ORDERS;
  if (leftPanelRefList) {
    var leftPanelKeys = [];
    for (var _iterator = _createForOfIteratorHelperLoose(leftPanelRefList.keys()), _step; !(_step = _iterator()).done;) {
      var key = _step.value;
      leftPanelKeys.push(key);
    }
    monthOrders = [].concat(leftPanelKeys, monthOrders);
    yearOrders = [].concat(leftPanelKeys, yearOrders);
    decadeOrders = [].concat(leftPanelKeys, decadeOrders);
  }
  if (disabled) {
    return [];
  }
  var result = [];
  switch (view) {
    case 'month':
      result = monthOrders;
      break;
    case 'year':
      result = yearOrders;
      break;
    case 'decade':
      result = decadeOrders;
      break;
  }
  if (isInDoubleCalendar && calendarPosition === CALENDAR_POSITION.LEFT) {
    result = arrRemove(result, PREV_BUTTON);
    result = arrRemove(result, NEXT_BUTTON);
  }
  return result;
}
export function getNextTabItem(tabOrders, current, e) {
  var index = tabOrders.indexOf(current);
  if (e.shiftKey) {
    index--;
  } else {
    index++;
  }
  //boundry checking
  index = index >= tabOrders.length ? 0 : index;
  index = index < 0 ? tabOrders.length - 1 : index;
  return tabOrders[index];
}
export var TIME_HOUR = 'time_panel_hour';
export var TIME_MINUTE = 'time_panel_minute';
export var TIME_AM_PM = 'time_panel_am_pm';
export var TIME_TABS_ORDERS = [TIME_HOUR, TIME_MINUTE, TIME_AM_PM];
export var TIME_MODE_TOTAL = 'TIME_MODE_TOTAL';
export var TIME_MODE_HOUR = 'TIME_MODE_HOUR';
export var TIME_MODE_MINUTE = 'TIME_MODE_MINUTE';
export function checkTabForInline(showInPicker, e, tabOrders, keyboardControlArea) {
  var isTab = e.key === 'Tab';
  var isShift = e.shiftKey;
  if (isTab && !showInPicker) {
    var tindex = tabOrders.indexOf(keyboardControlArea);
    var goToNextComponent = tindex === tabOrders.length - 1 && !isShift;
    var toToPrevComponent = tindex <= 0 && isShift;
    if (goToNextComponent || toToPrevComponent) {
      return true;
    }
  }
  return false;
}
export function getBeginValueForKeyboardHover(value, activeStartDate, view) {
  var beginValue;
  if (value instanceof Date && isInSameViewPage(activeStartDate, value, view)) {
    beginValue = value;
  } else if (value && value.length >= 1) {
    if (isInSameViewPage(activeStartDate, value[0], view)) {
      beginValue = value[0];
    } else if (isInSameViewPage(activeStartDate, value[1], view)) {
      beginValue = value[1];
    }
  }

  //truncate
  if (beginValue) {
    if (view === 'year') {
      beginValue = startOf('month', beginValue);
    } else if (view === 'decade') {
      beginValue = startOf('year', beginValue);
    }
    beginValue = dayjs(beginValue).toDate();
  }
  return beginValue;
}
export function getFirstFocusDate(value, view, activeStartDate) {
  var targetDate = new Date();
  if (value && value instanceof Array) {
    if (value.length !== 0) targetDate = value[0];
  } else if (value) {
    targetDate = value;
  }
  var currentViewStart = activeStartDate;
  var currentViewEnd;
  switch (view) {
    case 'month':
      currentViewEnd = dayjs(currentViewStart).endOf('month').toDate();
      break;
    case 'year':
      currentViewEnd = dayjs(currentViewStart).add(12, 'month').toDate();
      break;
    case 'decade':
      currentViewEnd = dayjs(currentViewStart).add(12, 'year').toDate();
      break;
    default:
      break;
  }
  if (dayjs(targetDate).isSameOrAfter(currentViewStart) && dayjs(targetDate).isSameOrBefore(currentViewEnd)) {
    return targetDate;
  } else {
    return currentViewStart;
  }
}